import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FilterOperator } from '@fgpp-ui/grid';
import { ProfilesNavigationService } from '../../../../profiles/services/profiles-navigation.service';
import { Alert } from '../../models/alert.model';
import { AlertType } from '../../models/enums/alert-type.enum';
import { InvestigationConfig } from '../models/investigation-config.model';

const ACTION_SEPARATOR = '|||';
const POWER_SIGN = '^';

@Injectable()
export class InvestigationService {

  private globalOffice = '***';

  private alertTypes = {
    [AlertType.ACCOUNT_POSITION]: 'LIQUIDITY_INVESTIGATION_CONFIG',
    [AlertType.MESSAGE_QUEUES]: 'MESSAGE_QUEUES_INVESTIGATION_CONFIG',
    [AlertType.INTERFACE_INACTIVITY]: 'PROFILES_INVESTIGATION_CONFIG',
    [AlertType.EVENT_INACTIVITY]: 'PROFILES_INVESTIGATION_CONFIG',
    [AlertType.SYSTEM_ERROR_LOG]: 'PROFILES_INVESTIGATION_CONFIG',
    [AlertType.FAILED_INCOMING_INTERACTION]: 'PROFILES_INVESTIGATION_CONFIG'
  };

  constructor(private router: Router, private profilesNavigationService: ProfilesNavigationService) { }

  investigate(alert: Alert) {
    const investigationConfig: InvestigationConfig = this.getInvestigationConfig(alert)[this.alertTypes[alert.type]];
    const route = investigationConfig.route;
    this.router.navigate([route], {
      queryParams: investigationConfig.queryParams
    });
  }

  private getLiquidityInvestigationConfig(): InvestigationConfig {
    return {
      route: '/home/liquidity'
    };
  }

  private getMessageQueuesInvestigationConfig(alert: Alert): InvestigationConfig {
    const values = alert.action.split(ACTION_SEPARATOR);
    const queue = values[0].split(POWER_SIGN)[0];
    const office = values[1];

    const queueType = values[0].includes(POWER_SIGN) ? 'system-queues' : 'custom-queues';
    const queryParams = { queueId: office !== this.globalOffice ? queue + '/' + office : queue };

    return {
      route: `/home/messages-center/${queueType}/messages/`,
      queryParams
    };
  }

  private getProfileInvestigationConfig(alert: Alert): InvestigationConfig {
    const config: InvestigationConfig = {
      route: this.profilesNavigationService.getRouterLinkByProfileId(alert.action.substring(alert.action.indexOf('P_=') + 3))
    };
    if (this.checkAlertInactiveProfile(alert)) {
      const filters = [{ columnId: 'INTERFACE_TYPES-INTERFACE_STATUS', operator: FilterOperator.EQUAL, value: ['NOT_ACTIVE']}];
      config.queryParams = { filters: JSON.stringify(filters) };
    }
    return config;
  }

  private checkAlertInactiveProfile(alert): boolean {
    const inactiveId = '456';
    if (alert.action.indexOf(inactiveId) !== -1) {
      return true;
    } else {
      return false;
    }
  }

  private getInvestigationConfig(alert: Alert) {
    return {
      'LIQUIDITY_INVESTIGATION_CONFIG': this.getLiquidityInvestigationConfig(),
      'MESSAGE_QUEUES_INVESTIGATION_CONFIG': this.getMessageQueuesInvestigationConfig(alert),
      'PROFILES_INVESTIGATION_CONFIG': this.getProfileInvestigationConfig(alert)
    };
  }
}
